
import request from '@/utils/request_common';
import { ContactUsData } from '@/interface/common';

export const sendEmailApi = (params: ContactUsData) =>  request({
    url: "/appMso/agent/sendEmailToFromGec",
    method: 'post',
    data: params
})
